import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addCajaDiaria, modifyCajaDiaria } from '../../reducers/caja_slice';
import { Form, Button, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';

const CajaDiariaForm = ({ cajaDiaria, handleClose, show }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false); // Estado para controlar el loading

  const { id, nombre, rolActivo, roles, caja, cuentacaja } = useSelector(state => state.sesion);
  const xcaja = caja; // nrocaja
  const xusuario = id; // Usuario provisional

  // Formatear fecha actual en formato YYYY-MM-DD (para input type="date")
  const today = new Date().toLocaleDateString('es-BO', {
    timeZone: 'America/La_Paz',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).split('/').reverse().join('-');

  // Obtener la lista de cajas desde el estado global
  const cajas = useSelector(state => state.caja.cajas);
  const selectedCaja = cajas && cajas.length > 0 ? cajas.find(caja => caja.nrocaja === xcaja) : null;

  const [formData, setFormData] = useState({
    nrocaja: xcaja,
    numero_cuenta: selectedCaja ? selectedCaja.numero_cuenta : '',
    id_caja: selectedCaja ? selectedCaja.id : '',
    fechaAper: today, // Fecha actual
    montoInicial: '',
    id_usuario: xusuario,
  });

  useEffect(() => {
    if (cajaDiaria) {
      setFormData(cajaDiaria);
    } else {
      setFormData({
        nrocaja: xcaja,
        numero_cuenta: selectedCaja ? selectedCaja.numero_cuenta : '',
        id_caja: selectedCaja ? selectedCaja.id : '',
        fechaAper: today,
        montoInicial: '',
        id_usuario: xusuario,
      });
    }
  }, [cajaDiaria, selectedCaja, today]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return; // Evitar múltiples clics si ya está cargando

    setLoading(true); // Activar estado de carga

    // Validar monto inicial
    if (formData.montoInicial < 0) {
      Swal.fire('Error', 'El monto inicial no puede ser menor a cero', 'error');
      setLoading(false);
      return;
    }

    // Obtener la hora actual en formato 24h (HH:MM:SS)
    const currentHour = new Date().toLocaleTimeString('en-GB');

    const updatedData = {
      ...formData,
      horaAper: currentHour,
    };

    try {
      if (cajaDiaria) {
        await dispatch(modifyCajaDiaria({ id: cajaDiaria.id, cajaDiaria: updatedData }));
        Swal.fire('Éxito', 'Apertura actualizada correctamente', 'success');
      } else {
        await dispatch(addCajaDiaria(updatedData));
        Swal.fire('Éxito', 'Apertura creada correctamente', 'success');
      }
      handleClose();
    } catch (error) {
      Swal.fire('Error', 'Hubo un problema al guardar', 'error');
    } finally {
      setLoading(false); // Desactivar estado de carga
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{cajaDiaria ? 'Editar Apertura' : 'Nueva Apertura'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          {/* Nro Caja (solo lectura) */}
          <Form.Group controlId="formNroCaja">
            <Form.Label>Nro Caja</Form.Label>
            <Form.Control
              type="text"
              name="nrocaja"
              value={formData.nrocaja}
              readOnly
            />
          </Form.Group>

          {/* Número de Cuenta (solo lectura) */}
          <Form.Group controlId="formNumeroCuenta">
            <Form.Label>Número Cuenta</Form.Label>
            <Form.Control
              type="text"
              name="numero_cuenta"
              value={formData.numero_cuenta}
              readOnly
            />
          </Form.Group>

          {/* Fecha de Apertura (solo lectura) */}
          <Form.Group controlId="formFechaAper">
            <Form.Label>Fecha de Apertura</Form.Label>
            <Form.Control
              type="date"
              name="fechaAper"
              value={formData.fechaAper}
              readOnly
            />
          </Form.Group>

          {/* Monto Inicial (editable) */}
          <Form.Group controlId="formMontoInicial">
            <Form.Label>Monto Inicial</Form.Label>
            <Form.Control
              type="number"
              name="montoInicial"
              value={formData.montoInicial}
              onChange={handleChange}
              min="0"
              required
            />
          </Form.Group>

          {/* Botón de Guardar/Actualizar (se desactiva durante el loading) */}
          <Button 
            variant="primary" 
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <span 
                  className="spinner-border spinner-border-sm" 
                  role="status" 
                  aria-hidden="true"
                ></span>
                {cajaDiaria ? ' Actualizando...' : ' Guardando...'}
              </>
            ) : (
              cajaDiaria ? 'Actualizar' : 'Guardar'
            )}
          </Button>

          <Button 
            variant="secondary" 
            onClick={handleClose} 
            className="ml-2"
            disabled={loading}
          >
            Cancelar
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CajaDiariaForm;